import { render, staticRenderFns } from "./DataInput.vue?vue&type=template&id=c9b23564&scoped=true"
import script from "./DataInput.vue?vue&type=script&lang=js"
export * from "./DataInput.vue?vue&type=script&lang=js"
import style0 from "./DataInput.vue?vue&type=style&index=0&id=c9b23564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b23564",
  null
  
)

export default component.exports